var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activeData.config["requireDetailAddr"] !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "填写详细地址" } },
            [
              _c("el-switch", {
                model: {
                  value: _vm.activeData.config["requireDetailAddr"],
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData.config, "requireDetailAddr", $$v)
                  },
                  expression: "activeData.config['requireDetailAddr']",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }